import { lazy } from "react";
import { componentLoader } from "utils/utils";
import { isMapLessPath } from "utils/firstMapView";
import { ROUTES } from "./AppConfig";

/**
 * The one import() of the Dashboard. App's lazy Dashboard and the boot
 * prefetch both call dashboardLoader.load(), so they share the same webpack
 * chunk group and the prefetch fills the cache React.lazy then reads.
 * (An object property, so tests can spy on it.)
 */
export const dashboardLoader = {
  load: () => import("components/Dashboard/Dashboard"),
};

/** App's lazy Dashboard (retries failed loads, see componentLoader). */
export const Dashboard = lazy(() =>
  componentLoader(() => dashboardLoader.load()),
);

// Pages that show something other than the Dashboard. The legal, privacy and
// usage pages show no map at all (utils/firstMapView).
const NON_DASHBOARD_ROUTES = [
  ROUTES.ADMIN,
  ROUTES.PUBLISH,
  ROUTES.USAGE,
  ROUTES.SUITABILITY,
];

/** Will this path end up on the Dashboard (the map)? */
export function willShowDashboard(pathname) {
  const path = pathname || "";
  if (isMapLessPath(path)) return false;
  return !NON_DASHBOARD_ROUTES.some(
    (route) => path === route || path.startsWith(`${route}/`),
  );
}

let prefetching = null;

/**
 * Start downloading the Dashboard chunk group now, so it overlaps the Login
 * chunk and the sign-in instead of starting after them. Does nothing on pages
 * that don't show the Dashboard. A failed prefetch is forgotten; the lazy
 * Dashboard loads (and retries) on its own when it renders.
 */
export function prefetchDashboard(pathname = window.location.pathname) {
  if (prefetching || !willShowDashboard(pathname)) return prefetching;
  prefetching = dashboardLoader.load().catch(() => {
    prefetching = null;
    return null;
  });
  return prefetching;
}
